/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getMemberClassificationByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetMemberClassificationById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getMemberClassificationByIdIdRegExpTwo)]).optional()
});

export type GetMemberClassificationById = zod.input<typeof GetMemberClassificationById>;
export type GetMemberClassificationByIdOutput = zod.output<typeof GetMemberClassificationById>;
